import React, { FC, useState } from 'react';
import { PatientTableItem } from 'types/types';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import styles from './styles.module.sass';
import { AlertDialog } from 'components';
import { useAppDispatch } from 'hooks';
import { patientsActions } from 'utils/store';
import { getDialogTitle } from './helpers';

export const ListItem: FC<PatientTableItem> = ({ fullName, email }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const dispatch = useAppDispatch();

  const onDeleteClick = async (email: string) => {
    await dispatch(patientsActions.deletePatientAndCaregiverConnectionByEmail(email));
    setIsDialogOpen(false);
  };

  const onCloseDialog = () => setIsDialogOpen(false);

  const openDialog = () => setIsDialogOpen(true);

  return (
    <div className={styles.item}>
      <p className={styles.name}>{fullName}</p>
      <a className={styles.email} href={`mailto:${email}`}>
        {email}
      </a>
      <AlertDialog
        title={getDialogTitle(fullName)}
        isOpen={isDialogOpen}
        onCancel={onCloseDialog}
        onConfirm={() => onDeleteClick(email)}
      />
      <DeleteForeverIcon className={styles.icon} onClick={openDialog} />
    </div>
  );
};
